import React, { useEffect, useState } from 'react'
import Card from '../../components/card/Card'
import NavHome from '../../components/navHome/NavHome'
import Waves from '../../components/waves/Waves'
import i18next from "i18next"

import "./home.scss"
import Lang from '../../components/lang/Lang'
import InfoPopUp from '../../components/infoPopUp/InfoPopUp'

export default function Home() {
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(()=>{
    if (localStorage.getItem("i18nextLng")?.length > 2){
        i18next.changeLanguage("es");
    }
  })
  return (
    <div className='home'>
      <NavHome/>
      <Lang/>
      <img onClick={()=>setShowPopUp(true)} src="https://cdn-icons-png.flaticon.com/512/167/167801.png" alt="" className='btnInfo'/>
      <InfoPopUp show={showPopUp} setShow={setShowPopUp}></InfoPopUp>
      <div className="cards">
        <Card/>
      </div>
      <div className="footer">
        <Waves/>
      </div>
    </div>
  )
}
